// extracted by mini-css-extract-plugin
module.exports = {"formBox":"style__formBox__IX+oM","captionBox":"style__captionBox__ZsQAY","regMsg":"style__regMsg__anDtx","logMsg":"style__logMsg__8Ycp5"};